/* eslint-disable no-unused-vars */
import React, { memo, useEffect, useState } from 'react';

import { useDebouncedCallback } from 'use-debounce';
import { useDispatch, useSelector } from 'react-redux';

import { geocoder } from '../utils/geocoderUtils';
import { setLoadOption, showOptionsList } from '../slices/searchSlice';
import { useTranslation } from 'react-i18next';

const testAreEquals = (prevRoad, nextRoad) => {
  if (prevRoad.value !== nextRoad.value) {
    return false;
  }
  if (prevRoad.typeSearch !== nextRoad.typeSearch) {
    return false;
  }
  return true;
};

const GeocoderInputComponent = ({
  value,
  typeSearch,
  handleGeocoder,
  autofocus = false,
  handlePressInput,
}) => {
  const dispatch = useDispatch();

  const { t } = useTranslation();

  const [input, setInput] = useState(value);
  const showPoi = useSelector((state) => state.poi.open);
  const limitBounding = useSelector((state) => state.search.limitSearch);
  const showSearch = useSelector((state) => state.search.open);
  const showOptionsSearch = useSelector((state) => state.search.showOptions);

  const bboxString = limitBounding.join(', ');

  const typeToRequest = {
    all: ['address', 'road', 'poi'],
    road: ['address', 'road'],
    poi: ['poi'],
  };

  const setGeocoderInput = useDebouncedCallback(
    async (value, type) => {
      if (value !== null && value !== '' && typeSearch) {
        const response = await geocoder.search(
          value,
          typeToRequest[type],
          bboxString
        );
        if (response !== undefined) {
          const { features } = response;
          const options = features.map((feature) => ({
            id: feature.id,
            label: feature.place_name,
            point: feature.center,
            type: feature.properties.categories,
          }));
          handleGeocoder(options);
        } else {
          return;
        }
        dispatch(setLoadOption(false));
        if (!showOptionsSearch) {
          dispatch(showOptionsList());
        }
      }
    },
    500,
    {
      maxWait: 5000,
    }
  );

  const handleGeocoderInput = (e) => {
    const textInput = e.target.value;
    setInput(textInput);
    dispatch(setLoadOption(true));
    setGeocoderInput(textInput, typeSearch);
  };

  useEffect(() => {
    setInput(value);

    return () => dispatch(setLoadOption(false));
  }, [value]);

  useEffect(() => {
    if (input && input !== '') {
      dispatch(setLoadOption(true));
      setGeocoderInput(input, typeSearch);
    }
  }, [typeSearch]);

  useEffect(() => {
    if (!showOptionsSearch && input !== '') {
      setInput('');
    }
  }, [showOptionsSearch]);

  return (
    <input
      className={`form-text ${showSearch && 'form-input-geocoder'}`}
      type='text'
      style={{ cursor: showPoi && 'pointer' }}
      readOnly={showPoi}
      autoFocus={autofocus}
      name='q'
      id='search'
      placeholder={t('search.geocoder_placeholder')}
      autoComplete='off'
      value={input ?? ''}
      onClick={handlePressInput}
      onChange={handleGeocoderInput}
    />
  );
};

export const GeocoderInput = memo(GeocoderInputComponent, testAreEquals);
